/**
 * Newsletter signup — the Fugue Lab App's public subscribe endpoint, which
 * upserts the contact into the app's contact kernel and enrolls the subscriber
 * in the welcome sequence. Studio owns no subscriber data; the app
 * (fugue-lab-{env}-data) is the single store.
 *
 * Endpoint: POST {APP_URL}/api/public/o/{slug}/subscribe  body: { email, name? }
 * (same app public API the intake form already calls; CORS already allows the
 * studio domain via the API Gateway `studio_domain` origin.)
 *
 * The FORM moved to `@gjl/studio-chrome` with the rest of the footer; only the
 * URL is assembled here. It has to be, and the package takes it as config:
 * `VITE_*` vars are inlined by Vite at build time, per app, so the same read in
 * shared source would resolve against whichever app was building.
 */
import { APP_URL } from './public-trpc'

/**
 * Slug of the Fugue Lab marketing org that owns the list. The org MUST exist in
 * the app (created in fugue-lab-{env}-data) for signups to land; until then the
 * endpoint returns 404. Override per environment via VITE_FUGUE_ORG_SLUG.
 * Default matches the org created by app/scripts/create-org.ts (slug 'fuguelab').
 */
export const FUGUE_ORG_SLUG = import.meta.env.VITE_FUGUE_ORG_SLUG || 'fuguelab'

export const NEWSLETTER_ENDPOINT = `${APP_URL}/api/public/o/${FUGUE_ORG_SLUG}/subscribe`
